enum Routes {
  OVERVIEW = "/insights/overview",
  OVERVIEW_PORT = "/insights/details/:page/:portId",
  VESSELS = "/insights/vessels/:imo"
}

export default Routes;
